import { Component, Input, NgZone, OnInit } from '@angular/core';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { Globals } from '../globals';
import { NewMapComponent } from '../new-map/new-map.component';
import { UserService } from '../user.service';
import { loadOpt } from 'src/environments/environment';
import { Storage } from '@ionic/storage-angular';

declare var google;


@Component({
  selector: 'app-new-address',
  templateUrl: './new-address.component.html',
  styleUrls: ['./new-address.component.scss'],
})
export class NewAddressComponent implements OnInit {
  public info = {
    address: '',
    numero: '',
    puerta: '',
    cp: ''
  }
  autocompleteItems: any[];
  
  GoogleAutocomplete: any;
  placesService: any;
  cpDisabled: boolean = true; // variable para deshabilitar el campo de codigo postal
  buttonDisabled: boolean = false; // variable para deshabilitar el botón de confirmar

  @Input() address;
  @Input() cp;
  @Input() num;
  

  constructor(
    public map: NewMapComponent,
    public user: UserService,
    public modalCtrl: ModalController,
    public nav: NavController,
    public global: Globals,
    public zone: NgZone,
    public stop: LoadingController,
    public storage: Storage

  ) {}

  ngOnInit() {
    this.buttonDisabled = false;
    this.storage.create();
    if (this.global.puerta_map) {
      this.info.puerta = this.global.puerta_map;
    }
    this.info.cp = this.cp;
    this.info.numero = this.num;
    this.info.address = this.address;
    this.global.nombreCalle = this.address;
    this.autocompleteItems = [];
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    this.clearSugerencias();
  }


  dismiss(){
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

  UpdateSearchResults(){
    this.cambiaDireccion();
    if (this.info.address == '') {
      this.autocompleteItems = [];
      this.buttonDisabled = true;
      return;
    }
    const config = {
      types: ['geocode'],
      input: this.info.address,
      componentRestrictions: {country: 'es'}
    };

    if (this.info.address == this.global.nombreCalle){
      this.autocompleteItems = [];

    }else{
      this.GoogleAutocomplete.getPlacePredictions(config,
        (predictions, status) => {
          // console.log(predictions)
          this.autocompleteItems = [];
          this.zone.run(() => { 
            if (this.global.showPred) {
              predictions.forEach((prediction) => {
                this.autocompleteItems.push(prediction);
              });
            } else {
              this.global.showPred = true;
            }
            
          });
        });
    
    }
    if (this.info.address == '') {
      this.autocompleteItems = [];
      return;
    }
  }

  ClearAutocomplete(){
    if (this.info.address == '') {
      this.autocompleteItems = []
      this.info.address = ''  
    }
    
  }

  async SelectSearchResult(place){
    
    this.buttonDisabled = false;
    this.global.disabled = false;
    const loading = await this.stop.create(loadOpt);
    await loading.present();
    this.global.nombreCalle = place.description;
    this.info.address = place.description;
    this.autocompleteItems = [];
    //this.address = place.structured_formatting.main_text; 

    this.placesService.getDetails({placeId: place.place_id}, (details) => {
        //console.log(details)
        this.global.lat = details.geometry.location.lat();
        this.global.lng = details.geometry.location.lng();

        details.address_components.filter((obj) => {
          if (obj.types[0] != 'postal_code'){
            this.info.cp = '';
            this.cpDisabled = false;
            document.getElementById('cpModal').classList.remove('inputReadonly');
          } else if (obj.types[0] == 'postal_code'){
            this.info.cp = obj.long_name;
            this.cpDisabled = true;            
            document.getElementById('cpModal').classList.add('inputReadonly');
          }
        });
        loading.dismiss();

    });
    this.autocompleteItems = [];
    setTimeout(() => loading.dismiss(), 4500);
  }

  cambiaDireccion(){
    if (this.info.address == this.global.nombreCalle) {
      this.buttonDisabled = false;
    }else{
      this.buttonDisabled = true;
    }
    
  }
  
  clearSugerencias(){
    this.autocompleteItems = [];
  }

  async confirmar(){
    let actual_address;
    //console.log('entraaaaaaaaaaaaaaaaaa')
    await this.storage.get('actual_address').then(data => {
      //console.log('arriba del if')
      if (data) {
        //console.log(data)
        actual_address = data;
      } 
      //console.log('debajo del if')
    })
    
    let calle_num = this.info.address + ' ' + this.info.numero;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${calle_num}, ${this.info.cp}&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs`
    await fetch(url)
      .then((response) => response.json()
      .then((responseJson) => {
          
            actual_address.lat = responseJson.results[0].geometry.location.lat;
            actual_address.lng = responseJson.results[0].geometry.location.lng;
            actual_address.postal_code = this.info.cp;
            actual_address.number = this.info.numero;
            actual_address.address = this.info.address;
            actual_address.door = this.info.puerta;
            
            this.user.isLoggedIn
              ? actual_address.user_id = this.user.data.id
              : actual_address.user_id = 0

            actual_address.id_address = '';
          

      }));
    await this.storage.set('address', calle_num);
    await this.storage.set('postal_code', this.info.cp);
    await this.storage.set('number', this.info.numero);
    await this.storage.set('door', this.info.puerta);
    await this.storage.set('actual_address', actual_address);
    
    this.dismiss();
    this.global.cp_map = this.cp;
    this.global.address_map = this.info.address;   
     
    this.nav.navigateForward(['two-worlds']);
  }

}